import { openGlobalModal } from 'actions/modal';

import { getCourseList, getCourseInfo, getMemberCourseList, getCourseRecommend, checkCourseTheme } from 'actions/course';
import { getMemberData } from 'actions/member';
import { getCouponList } from 'actions/coupon';

export default store => ({
	path: 'course',
	indexRoute: {
		getComponent: (nextState, cb) =>
			require.ensure(
				[],
				require => {
					const component = require('./Home').default;
					cb(null, component);
				},
				'Course',
			),
		onEnter: () => {
			store.dispatch(getCourseList());
			store.dispatch(getMemberCourseList());
		},
	},
	childRoutes: [
		{
			path: ':id',
			indexRoute: {
				getComponent: (nextState, cb) =>
					require.ensure(
						[],
						require => {
							const component = require('./Info').default;
							cb(null, component);
						},
						'CourseInfo',
					),
				onEnter: ({ params }) => {
					store.dispatch(getMemberData());
					store.dispatch(getCourseInfo(params.id));
					store.dispatch(getCouponList());
					store.dispatch(getMemberCourseList());
				},
			},
			childRoutes: [
				{
					path: 'signup(/:coupon)',
					indexRoute: {
						getComponent: (nextState, cb) =>
							require.ensure(
								[],
								require => {
									const component = require('./Signup').default;
									cb(null, component);
								},
								'CourseSignup',
							),
						onEnter: ({ params }) => {
							store.dispatch(getMemberData());
							const { auth: { token: { accessToken } } } = store.getState();
							const {
								members: {
									emailVerify,
									mobileVerify,
									name,
									identity,
								},
							} = store.getState();
							if (accessToken === '') {
								store.dispatch(openGlobalModal('courseSignupNotLogin'));
							} else if (accessToken !== '') {
								if (emailVerify === 0 || mobileVerify === 0) {
									store.dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
									if (name === '' || name === null || identity === null) {
										store.dispatch(openGlobalModal('memberInfoEmailMobileNotyet'));
									}
								} else {
									store.dispatch(checkCourseTheme(params.id));
									store.dispatch(getCouponList());
									store.dispatch(getCourseInfo(params.id));
								}
							}
						},
					},
				},
				{
					path: 'result',
					indexRoute: {
						getComponent: (nextState, cb) =>
							require.ensure(
								[],
								require => {
									const component = require('./Result').default;
									cb(null, component);
								},
								'CourseResult',
							),
						onEnter: ({ params }) => {
							store.dispatch(getCourseInfo(params.id));
							store.dispatch(getCourseRecommend(params.id));
						},
					},
				},
			],
		},
	],
});



// WEBPACK FOOTER //
// ./src/routes/Course/index.js